import InputText from 'Support/components/inputs/InputText.vue';
import NumberMixin from 'Support/components/lists/mixins/number.mixin';

export default {
  components: {
    InputText,
  },
  mixins: [NumberMixin],
  props: {
    inputKey: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: String,
      default: '16',
    },
    required: {
      type: Boolean,
      default: false,
    },
    decimals: {
      type: [Number],
      default: 4,
    },
    separator: {
      type: [String],
      default: ',',
    },
    thousands: {
      type: Boolean,
    },
  },
  data: () => ({
    nativeError: '',
  }),
  computed: {
    getPrefixColor() {
      return this.disabled ? 'color: #9f9f9f' : 'color: black';
    },
    valueData: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.formatNumber(newValue);
      },
    },
  },
  created() {
    if (this.value) {
      this.valueData = this.value;
    }
  },
  methods: {
    formatNumber(value) {
      if (String(value).match(/[a-z]/i)) {
        this.nativeError = 'Valor inválido';
        return;
      }

      this.nativeError = '';

      this.$emit('input', value !== '' ? this.replaceNumber(value) : value);
    },

    replaceNumber(value) {
      return value;
    },
  },
};
